module.exports = __webpack_public_path__ + "static/media/worldAlert.pictogram.73390af1.svg";